export enum SortingOrder {
    asc = 'asc', desc = 'desc'
}
